import { createLogic, StandardAction } from "redux-logic";
import {
  SET_LOGIN_STATUS,
  SET_ERROR,
  SET_DISPATCH_TIMESTAMP,
  ApplicationMode,
} from "../types/ApplicationStateTypes";
import {
  clearAppState,
  clearError,
  setLatestDispatchTimestamp,
  setLoadingStatus,
  setPersistedCartID,
  setPersistedSortID,
} from "../reducers/applicationStateReducer";
import { IErrorModel } from "../../interfaces/Error/IErrorModel";
import { clearCartState } from "../reducers/cartReducer";
import { clearInstructions } from "../reducers/instructionStateReducer";
import { clearLoginState } from "../reducers/loginInfoReducer";
import { IPayloadWrapper, PayloadWrapper } from "../types/PayloadWrapper";
import { clearBoxReviewState } from "../reducers/boxReviewReducer";
import { clearAFrameModeState } from "../reducers/aframeModeReducer";
import { clearReviewBoxData } from "../reducers/aFrameReviewBoxReducer";
import { clearRxModeState } from "../reducers/rxBoxModeReducer";

/**
 * -----------------------------
 *  Redux Logic Definitions
 * -----------------------------
 */
const errorLifeSpanMS: number = 5000;

const addTimestampOnDispatch = createLogic({
  type: "*",
  process({ action }: { action: StandardAction<string> }, dispatch, done) {
    if (action.type !== SET_DISPATCH_TIMESTAMP)
      dispatch(setLatestDispatchTimestamp(new PayloadWrapper(Date.now())));
    done();
  },
});

const errorLogic = createLogic({
  type: SET_ERROR,
  validate({ action }: { action: StandardAction<string, IErrorModel> }, allow) {
    action.payload.message =
      typeof action.payload.message === "string" && action.payload.message.length > 0
        ? action.payload.message
        : "Okänt fel";
    allow(action);
  },
  process({ getState, action }, dispatch, done) {
    dispatch(setLoadingStatus(new PayloadWrapper(false)));
    setTimeout(() => {
      dispatch(clearError());
      done();
    }, errorLifeSpanMS);
  },
});

const logoutLogic = createLogic({
  type: SET_LOGIN_STATUS,
  process(
    {
      action,
      getState,
    }: { action: StandardAction<string, IPayloadWrapper<boolean>>; getState: any },
    dispatch,
    done
  ) {
    if (action.payload.value === false) {
      if (getState().applicationStateReducer.appMode === ApplicationMode.PackingMode) {
        const sortID = getState()!.cartReducer!.sortID;
        const cartID = getState()!.cartReducer!.currentCart;
        dispatch(setPersistedCartID(new PayloadWrapper(cartID)));
        dispatch(setPersistedSortID(new PayloadWrapper(sortID)));
      }
      if (getState().applicationStateReducer.appMode === ApplicationMode.AFrameReviewMode) {
        dispatch(clearAFrameModeState());
        dispatch(clearReviewBoxData());
      }

      if (getState().applicationStateReducer.appMode === ApplicationMode.RxBoxMode) {
        dispatch(clearRxModeState())
      }

      dispatch(clearAppState());
      dispatch(clearCartState());
      dispatch(clearInstructions());
      dispatch(clearLoginState());
      dispatch(clearBoxReviewState());
    }
    done();
  },
});

export { errorLogic, logoutLogic, addTimestampOnDispatch };
